import React, { useState } from "react";
import { Popover } from "antd";
import styles from "./FilterSelector.module.css";
import { IoFilterOutline } from "react-icons/io5";

const FilterSelector = ({ handleFilterChange }) => {
  const [open, setOpen] = useState(false);
  
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  return (
    <Popover
      content={<div></div>}
      title="Filters"
      trigger="click"
      open={open}
      placement="bottom"
      onOpenChange={handleOpenChange}
    >
      <div className={styles.picker_wrap}>
        <IoFilterOutline className={styles.filter_icon} />
        Filters
      </div>
    </Popover>
  );
};
export default FilterSelector;
